import React, { ComponentProps, FunctionComponent } from "react";

const WinningRibbonIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 18 18",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M8.67718 11.9307C7.69848 11.9307 6.77564 11.6894 5.96069 11.2691V16.0537C5.96069 16.6954 6.32132 16.8374 6.7605 16.3698L7.87738 15.181C8.3175 14.7134 9.03686 14.7144 9.47698 15.181L10.5939 16.3698C11.033 16.8364 11.3927 16.6954 11.3927 16.0537V11.2701C10.5778 11.6884 9.65585 11.9307 8.67718 11.9307Z",
      stroke: "currentColor",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M8.67718 0.645325C5.73535 0.645325 3.34937 3.03148 3.34937 5.97217C3.34937 8.914 5.73457 11.3 8.67718 11.3C11.6207 11.3 14.005 8.91477 14.005 5.97217C14.005 3.03131 11.6208 0.645325 8.67718 0.645325ZM10.6648 9.03515L8.67718 7.98832L6.68858 9.03421L7.06812 6.81844L5.46001 5.25199L7.68336 4.92829L8.6772 2.91318L9.67388 4.92829L11.8972 5.25199L10.2872 6.81844L10.6648 9.03515Z",
      stroke: "currentColor",
    })
  );
};

const ForwardRef = React.forwardRef(WinningRibbonIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
